import PropTypes from 'prop-types';
import React from 'react';
import styled from '@emotion/styled';
import { themeGet } from 'styled-system';
import { Box } from 'roo-ui/components';
import PhoneFiltersModal from './PhoneFiltersModal';
import { mediaQuery } from 'lib/styledSystem';

const FixedPositionControls = styled(Box)`
  display: flex;
  position: fixed;
  bottom: 24px;
  left: 0;
  right: 0;
  justify-content: center;

  opacity: ${(props) => (props.visible ? '1' : '0')};
  transition: opacity 0.25s ease-in-out;
  visibility: ${(props) => (props.visible ? 'visible' : 'hidden')};

  ${mediaQuery.minWidth.sm} {
    display: none;
    visibility: hidden;
  }
`;

const ControlsWrapper = styled(Box)`
  border-radius: ${themeGet('radii.rounded')};
  background-color: ${themeGet('colors.greys.charcoal')};
  box-shadow: 0px -4px 8px 0px rgba(51, 51, 51, 0.15), 0px 4px 8px 0px rgba(51, 51, 51, 0.15);
  display: flex;
  height: 48px;
  justify-content: center;
`;

const PhoneFilters = ({ visible }) => (
  <FixedPositionControls visible={visible}>
    <ControlsWrapper>
      <Box minWidth="126px">
        <PhoneFiltersModal title="Filter room offers" />
      </Box>
    </ControlsWrapper>
  </FixedPositionControls>
);

PhoneFilters.propTypes = {
  visible: PropTypes.bool,
};

PhoneFilters.defaultProps = {
  visible: true,
};

export default PhoneFilters;
